import React, { Component } from 'react'
import ReactTable from "react-table"
import 'react-table/react-table.css'
import request from '../../lib/requester'
import _ from 'lodash'
import ReactExport from "react-export-excel"
import moment from 'moment'

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn


class principal extends Component {


    constructor(props) {
        super(props);

        this.state = {
            dataTable: [],
            baseTable: [],
            name: '',
            initial: '',
            email: '',
            npwp: '',
            phone: '',
            address_1: '',
            address_2: '',
            address_3: '',
            cp_name: '',
            cp_phone: '',
            pic_aam: '',
            pic_aam_title: '',
            search: '',
            success: '',
            error: '',
            user: JSON.parse(window.localStorage.getItem('is_user'))
        }
    }

    componentDidMount = () => {
        let url = '/api/infostep/v1/setup/principal'
        let param = {
            org_id: this.state.user.org_id
        }
        this.setState({ loading: true })
        request.postInfostep(url, param, {
            success: function (response) {
                let { data } = response.data
                data.map((item, index) => {
                    item.formatted_start_date = moment(item.start_date).format('DD-MM-YYYY')
                    item.formatted_end_date = moment(item.end_date).format('DD-MM-YYYY')
                    return item
                })
                this.setState({ loading: false, dataTable: data, baseTable: data })
            }.bind(this),
            error: function (e) {
                this.setState({ loading: false })
            }.bind(this)
        })
    }

    renderTable = () => {
        const data = {
          columns: [
            {
              Header: "ID",
              accessor: "org_id",
              width: 50,
            },
            {
              Header: "Name",
              accessor: "org_name",
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 250,
            },
            {
              Header: "Initial",
              accessor: "org_initial",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="initial"
                    name="initial"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "org_initial");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              //   width: 250,
            },
            {
              Header: "Email",
              accessor: "email",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="email"
                    name="email"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "email");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 250,
            },
            {
              Header: "Phone",
              accessor: "phone",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="phone"
                    name="phone"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "phone");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 200,
            },
            {
              Header: "Npwp",
              accessor: "npwp",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "npwp");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 250,
            },
            {
              Header: "Address 1",
              accessor: "address_1",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "address_1");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 400,
            },
            {
              Header: "Address 2",
              accessor: "address_2",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "address_2");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 400,
            },
            {
              Header: "Address 3",
              accessor: "address_3",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "address_3");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 400,
            },
            {
              Header: "PIC AAM",
              accessor: "pic_aam",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "pic_aam");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 300,
            },
            {
              Header: "PIC AAM Title",
              accessor: "pic_aam_title",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "pic_aam_title");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 300,
            },
            {
              Header: "Contact Person Name",
              accessor: "cp_name",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "cp_name");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 300,
            },
            {
              Header: "Contact Person Phone",
              accessor: "cp_phone",
              Cell: (row) => (
                <span>
                  <input
                    type="text"
                    className="form-control"
                    id="npwp"
                    name="npsp"
                    Value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable(e, row, "cp_phone");
                    }}
                  />
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
              width: 200,
            },
            {
              Header: "Active",
              accessor: "active_flag",
              width: 150,
              Cell: (row) => (
                <span>
                  <select
                    className="form-control"
                    name="activeFlag"
                    value={row.value}
                    onChange={(e) => {
                      this.handleChangeValueTable.bind(this, "active_flag");
                    }}
                  >
                    <option value="Y"> Y </option>
                    <option value="N"> N </option>
                  </select>
                </span>
              ),
              filterable: true,
              Filter: ({ filter, onChange }) => (
                <input
                  placeholder="search.."
                  onChange={(event) => onChange(event.target.value)}
                  //   defaultValue="Search.."
                  value={filter ? filter.value : ""}
                  //   value="2111"
                  style={{
                    width: "100%",
                    // backgroundColor: "gray",
                    //   color: "gray",
                  }}
                />
              ),
            //   width: 250,
            },
            {
              Header: "",
              accessor: "org_id",
              width: 90,
              Cell: (row) => (
                <span>
                  <button
                    className="btn btn-success btn-sm"
                    onClick={() => {
                      this.goUpdate(row);
                    }}
                  >
                    Update <i className="fas fa-check" />
                  </button>
                </span>
              ),
            },
          ],
          rows: this.state.dataTable,
        };
        return (
          <ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
            defaultFilterMethod={(filter, row, column) => {
              let columnes = row[filter.id];
              return columnes
                ? columnes.toLowerCase().includes(filter.value.toLowerCase())
                : "";
            }}
          />
        );
    }

    handleChangeActive = (event) => {
        let value = event.target.value
        let name = event.target.name

        // this.setState({ activeflag: value })
        window.setTimeout(() => {
            console.log(this.state.activeflag)
        }, 100)
    }

    handleSearch = (e) => {
        let value = e.target.value
        this.setState({ search: value })
        let baseTable = _.filter(this.state.baseTable, function (o) {
            return o.username.toLowerCase().includes(value.toLowerCase())
        })
        this.setState({ dataTable: baseTable })
    }

    goUpdate = (rows) => {
        let { row } = rows
        let url = "/api/infostep/v1/setup/updateprincipal"
        let param = {
            id: row.org_id,
            name: row.org_name,
            initial: row.org_initial,
            email: row.email,
            npwp: row.npwp,
            phone: row.phone,
            activeflag: row.active_flag,
            address_1: row.address_1,
            address_2: row.address_2,
            address_3: row.address_3,
            pic_aam: row.pic_aam,
            pic_aam_title: row.pic_aam_title,
            cp_name: row.cp_name,
            cp_phone: row.cp_phone,
            userid: JSON.parse(window.localStorage.getItem('is_user')).user_id
        }

        this.setState({ loading: true })
        request.postInfostep(url, param, {
            success: function (response) {
                this.setState({ loading: false, success: response.data.message })

                window.scrollTo(0, 0)
                let app = this
                window.setTimeout(() => {
                    window.location.reload(false);
                }, 2000)
            }.bind(this),
            error: function (e) {
                window.scrollTo(0, 0)
                this.setState({ loading: false, error: ['Failed to submit, please try again'] })
            }.bind(this)
        })
    }

    handleChangeValue = (event) => {
        let target = event.target.label
        let value = event.target.value
        let valname = event.target.name
        if (valname === 'insname') {
            this.setState({ name: value })
        }
        else if (valname === 'insinitial') {
            this.setState({ initial: value })
        }
        else if (valname === 'insnpwp') {
            this.setState({ npwp: value })
        }
        else if (valname === 'insemail') {
            this.setState({ email: value })
        }
        else if (valname === 'insphone') {
            this.setState({ phone: value })
        } else {
            this.setState({ [valname]: value })
        }
    }


    handleSave = () => {
        if (this.validateForm()) {
            let url = "/api/infostep/v1/setup/insertprincipal"
            let param = {
                name: this.state.name,
                initial: this.state.initial,
                email: this.state.email,
                npwp: this.state.npwp,
                phone: this.state.phone,
                pic_aam: this.state.pic_aam,
                pic_aam_title: this.state.pic_aam_title,
                cp_name: this.state.cp_name,
                cp_phone: this.state.cp_phone,
                address_1: this.state.address_1,
                address_2: this.state.address_2,
                address_3: this.state.address_3,
                userid: JSON.parse(window.localStorage.getItem('is_user')).user_id
            }

            this.setState({ loading: true })
            request.postInfostep(url, param, {
                success: function (response) {
                    this.setState({ loading: false, success: response.data.message })

                    window.scrollTo(0, 0)
                    let app = this
                    window.setTimeout(() => {
                        window.location.reload(false);
                        // app.props.history.push('/admin/setup/master/principal')
                        // this.renderTable()
                    }, 2000)
                }.bind(this),
                error: function (e) {
                    window.scrollTo(0, 0)
                    this.setState({ loading: false, error: ['Failed to submit, please try again'] })
                }.bind(this)
            })
        }
    }

    validateForm = () => {
        let count = 0
        let error = []
        this.setState({ error: [], success: '' })
        if (this.state.name === '') {
            error.push('Principal Name is empty')
            ++count
        } else if (this.state.initial === '') {
            error.push('Principal Initial is empty')
            ++count
        } else if (this.state.npwp === '') {
            error.push('Npwp is empty')
            ++count
        } else if (this.state.phone === '') {
            error.push('Phone is empty')
            ++count
        } else if (this.state.email === 0) {
            error.push('Email is empty')
            ++count
        } else if (this.state.address_1 === 0) {
            error.push('Address 1 is empty')
            ++count
        } else if (this.state.pic_aam === 0) {
            error.push('PIC AAM is empty')
            ++count
        } else if (this.state.pic_aam_title === 0) {
            error.push('PIC AAM Title is empty')
            ++count
        } else if (this.state.cp_name === 0) {
            error.push('Contact Person Name is empty')
            ++count
        } else if (this.state.cp_phone === 0) {
            error.push('Contact Person Phone is empty')
            ++count
        }

        if (count > 0) {
            this.setState({ error: error })
            window.scrollTo(0, 0)
            return false
        } else {
            return true
        }
    }


    showSuccess = () => {
        if (this.state.success.length > 0) {
            return (
                <div className="alert alert-success" role="alert">
                    {this.state.success}
                </div>
            )
        }
    }
    showError = () => {
        if (this.state.error.length > 0) {
            return (
                <div className="alert alert-danger" role="alert">
                    <ul>
                        {this.state.error.map((item, index) => {
                            return (<li key={index}>{item}</li>)
                        })}
                    </ul>
                </div>
            )
        }
    }

    handleChangeValueTable = (e, rows, columns) => {
        let { dataTable } = this.state
        let index = rows.index
        let value = e.target.value
        dataTable[index][columns] = value
        this.setState(dataTable)
    }

    render() {
        return (
            <div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="row ml-1">
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">List</div>
                                    <div className="card-body">
                                        {this.showSuccess()}
                                        {this.showError()}
                                        {/* <div className="row">
                                            <div className="col-lg-4">
                                                <input type="text" className="form-control" placeholder="Search Principal..." onChange={this.handleSearch.bind(this)} />
                                            </div>
                                        </div> */}
                                        <div className="clearfix">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                {this.renderTable()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="clearfix">&nbsp;</div>
                            <div className="col-lg-12">
                                <div className="card card-info">
                                    <div className="card-header">Create New Principal</div>
                                    <div className="card-body">
                                        <div className="clearfix">&nbsp;</div>
                                        <div className="row">
                                            <div className="col-lg-12">
                                                {/* { this.renderTable() } */}
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Principal Name</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insname" name="insname" placeholder="" defaultValue={this.state.name} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Principal Initial</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insinitial" name="insinitial" placeholder="" defaultValue={this.state.initial} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Principal Email</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insemail" name="insemail" placeholder="" defaultValue={this.state.email} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Principal Phone</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insphone" name="insphone" placeholder="" defaultValue={this.state.phone} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Principal NPWP</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insnpwp" name="insnpwp" placeholder="" defaultValue={this.state.npwp} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Contact Person Name</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insnpwp" name="cp_name" placeholder="" defaultValue={this.state.cp_name} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Contact Person Phone</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insnpwp" name="cp_phone" placeholder="" defaultValue={this.state.cp_phone} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">PIC AAM Name</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insnpwp" name="pic_aam" placeholder="" defaultValue={this.state.pic_aam} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">PIC AAM Title</label>
                                                            <div className="col-sm-8">
                                                                <input type="text" className="form-control" id="insnpwp" name="pic_aam_title" placeholder="" defaultValue={this.state.pic_aam_title} onChange={this.handleChangeValue.bind(this)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6" >
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Address 1</label>
                                                            <div className="col-sm-8">
                                                                <textarea className="form-control" rows={4} name="address_1" value={this.state.address_1} onChange={this.handleChangeValue.bind(this)}></textarea>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Address 2</label>
                                                            <div className="col-sm-8">
                                                                <textarea className="form-control" rows={4} name="address_2" value={this.state.address_2} onChange={this.handleChangeValue.bind(this)}></textarea>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row">
                                                            <label htmlFor="inputEmail3" className="col-sm-4 col-form-label">Address 3</label>
                                                            <div className="col-sm-8">
                                                                <textarea className="form-control" rows={4} name="address_3" value={this.state.address_3} onChange={this.handleChangeValue.bind(this)}></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-9">
                                                <button type="button" className="btn btn-success" onClick={this.handleSave.bind(this)} >Create New</button>&nbsp;
                                                {/* <button type = "button" className="btn btn-warning" onClick={ this.handleCancel.bind(this) }>Cancel</button> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }



}
export default principal